import type { FC } from 'react';

import type {
  InfoStateProps,
  InternalButtonProps,
} from '../info-state/info-state';

import errorIcon from './assets/error.svg';
import * as Styled from './error-state.styles';

type ErrorStateProps = {
  buttonProps?: InternalButtonProps;
  testId?: string;
  onReloadClick?: () => void;
  headlineCopyKey?: string;
};

export const ErrorState: FC<ErrorStateProps & InfoStateProps> = ({
  onReloadClick,
  buttonProps,
  ...props
}) => (
  <Styled.InfoState
    icon={errorIcon}
    headlineCopyKey="EP_ERROR"
    buttonProps={{
      copyKey: 'EP_ERROR_RELOAD_CTA',
      onClick: onReloadClick,
      variant: 'tertiary',
      ...buttonProps,
    }}
    {...props}
  />
);
